import { DesignTokens } from '@rbilabs/components-library';
import { DefaultTheme } from 'styled-components';

import { theme as brandTheme } from 'components/layout/brand-theme';

import { designTokens } from './constants/design-tokens';

export const theme: DefaultTheme = {
  ...brandTheme,
  token(tokenName: keyof DesignTokens) {
    return designTokens[tokenName];
  },
};
